import React from 'react';

type Props = {
  title: string;
  description: string;
};

export const CreationHubHeader = ({ title, description }: Props) => {
  return (
    <div className="creation-hub-header">
      <h3 className="creation-hub-header__title">{title}</h3>
      <p className="creation-hub-header__description">{description}</p>
    </div>
  );
};
